<div
  *ngIf="show && banner"
  class="fixed z-[1100] bottom-6 right-6 md:right-8 w-[calc(100%-48px)] md:w-[380px] animate-slide-in-out-right"
>
  <div
    class="flex gap-3 items-center p-3 bg-white rounded-[16px] shadow-[0px_1px_4px_0px_rgba(169,188,217,0.05),0px_8px_30px_0px_rgba(0,56,139,0.1)]"
  >
    <div
      class="flex items-center p-2 rounded-[12px] shrink-0"
      [ngClass]="banner.type === 'success' ? 'bg-[#E4FAE2]' : 'bg-[#FDECEA]'"
    >
      <ui-illustrative-icon
        *ngIf="banner.type === 'success'"
        name="i-success"
        size="xs"
        fill="success-300"
      ></ui-illustrative-icon>
      <ui-illustrative-icon
        *ngIf="banner.type === 'error'"
        name="i-error"
        size="xs"
        fill="critical-300"
      ></ui-illustrative-icon>
    </div>
    <div class="flex flex-col gap-0.5 flex-1 min-w-0">
      <ui-paragraph
        type="p14"
        mobile-type="p14"
        font-weight="semibold"
        text-color="neutrals-900"
        [content]="banner.title"
      />
      <ui-paragraph
        type="p12"
        mobile-type="p12"
        font-weight="regular"
        text-color="neutrals-600"
        [content]="banner.message"
      />
    </div>
  </div>
</div>
